import styled from 'styled-components';

const StyledRect = styled.rect<{ $active: boolean }>`
	opacity: ${(props) => (props.$active ? 1 : 0.1)};
	transition: opacity 0.3s ease;
`;

const StyledCircle = styled.circle<{ $active: boolean }>`
	fill: ${(props) => (props.$active ? 'black' : 'white')};
	cx: ${(props) => (props.$active ? 10 : 20)}px;
	transition:
		fill 0.3s ease,
		cx 0.3s ease;
`;

const StyledSvg = styled.svg`
	cursor: pointer;
`;

export { StyledRect, StyledCircle, StyledSvg };
